import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { AuthorNames } from "scmp-app/components/article/article-author-block/author-names";
import { AuthorLocation } from "scmp-app/components/article/article-author-block/author-names/styles";
import { DefaultArticleDate } from "scmp-app/components/article/article-date/default-article-date";
import { PublishedDateContainer } from "scmp-app/components/article/article-date/default-article-date/styles";
import { StyledAuthorName } from "scmp-app/components/author/author-name/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  font-family: ${fontRoboto};

  ${StyledAuthorName} {
    color: #001246;

    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledAuthorNames = styled(AuthorNames)`
  color: #000000;
  font-weight: 900;
  font-size: 12px;
  line-height: 14px;

  ${AuthorLocation} {
    padding-inline-start: 4px;

    color: #000000;
    font-weight: 400;
  }
`;

export const StyledDefaultArticleDate = styled(DefaultArticleDate)`
  display: flex;

  min-block-size: auto;
  margin-block-start: 4px;

  color: #000000;
  font-size: 11px;
  font-family: ${fontRoboto};
  line-height: 12.9px;

  cursor: text;

  ${props => props.theme.breakpoints.up("tablet")} {
    min-block-size: auto;
  }

  ${PublishedDateContainer} {
    margin-inline-end: 8.5px;
    &:after {
      content: "/";

      margin: 0;

      border: none;

      transform: none;
    }

    time {
      margin-inline-end: 4px;
    }
  }
`;
